import { shopServiceType } from '@/commonTypes';
import React from 'react';
import styles from './styles.module.css';
import generalStyle from '../styles.module.css';
import { Breadcrumb } from '@/components/general/BreadCrumb';
import ServiceShopHeroInfo from './ServiceShopHeroInfo';
import ServiceReserveModal from '@/components/Modals/ModalsContainer/ServiceReserveModal';
import ServicePrice from './ServicePrice';

export default function ServiceShopHero({ data }: { data?: shopServiceType }) {
  return (
    <section className={`${styles.hero}`}>
      <div className={`container`}>
        <Breadcrumb
          items={[
            { label: 'کارا', to: '/' },
            { label: 'خدمات', to: '/shop-services' },
            { label: `${data?.shop?.title}`, to: `/shops/${data?.shop?.slug}` },
            { label: data?.title || '' },
          ]}
          className={styles.breadcrumb}
          currentStyle={styles.current}
        />
        <div className={`${generalStyle.heroGrid}`}>
          <ServiceShopHeroInfo data={data} />
          <ServiceReserveModal
            className={`${styles.reserve}`}
            reserveContent={styles.reserveContent}
            timeSlotClass={styles.timeSlotClass}
            page="service"
          >
            <ServicePrice data={data} />
          </ServiceReserveModal>
        </div>
      </div>
    </section>
  );
}
